import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "src/api/firebase";
import { useAuth } from "src/context";

export const AppInitializer = ({ children }: { children: React.ReactNode }) => {
  const { setUser } = useAuth();

  useEffect(() => {
    const unsubcribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      updateSentryUser(currentUser);
    });

    return () => {
      unsubcribe();
    };
  }, []);

  const updateSentryUser = (user: typeof auth.currentUser | null) => {
    if (user) {
      Sentry.setUser({ id: user.uid });
    } else {
      Sentry.setUser(null);
    }
  };

  return <>{children}</>;
};
